import { CrudState } from "@/store/Crud/State";

export class State extends CrudState {
  coursesAndTheoryLessons: Array<any> = [];
  upcomingTheoryCourses: Array<any> = [];
  filterStudentTheoryCourses: Array<any> = [];
}
